import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { CRMResposta } from 'src/app/models/crm/crmresposta';

@Injectable({
  providedIn: 'root'
})
export class CrmrespostaService {

  constructor(private http: HttpClient) { }

  consultarRespostas(tipo) {
    return this.http.get<CRMResposta[]>(globals.apiUrl + '/api/CRMResposta/Lista', { params: new HttpParams().set('tipo', tipo) });
  }

  consultarRespostasComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, tipo, statusCadastro) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipo', tipo);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    if (statusCadastro !== null) {
      parametros = parametros.set('statusCadastro', statusCadastro);
    }

    return this.http.get<any>(globals.apiUrl + '/api/CRMResposta/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdResposta(idResposta) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMResposta/Buscar',
      { params: new HttpParams().set('id', idResposta) });
  }

  salvar(resposta: CRMResposta) {
    return this.http.post(globals.apiUrl + '/api/CRMResposta/Salvar', resposta);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/CRMResposta/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}